import React from 'react';
import { Box } from '@blueprint/ui';

export const TextInputBox = ({ children }) => {
    return <Box marginTop={['5px', '5px', '5px', '24px']}>{children}</Box>;
};
